/**
 * Defines the events associated with the Checkbox component.
 */
export const CheckboxEvents = {
  CHECKED: 'luds-checkbox:checked',
} as const;

export const CheckboxGroupEvents = {
  VALUE_CHANGED: 'luds-checkbox-group-value:changed',
} as const;

// Define the CheckedEvent interface
export interface CheckedEvent {
  checked: boolean;
  disabled: boolean;
  indeterminate: boolean;
  label: string;
  checkboxAriaLabel: string | null;
  name: string;
  id: string;
  value: string;
}

export interface CheckboxOption {
  label?: string;
  useHtmlLabel?: boolean;
  value: string;
  checked?: boolean;
  disabled?: boolean;
  indeterminate?: boolean;
  checkboxAriaLabel?: string;
  name?: string;
  id?: string;
}
